module.exports = "/virtual-football-league/img/amblems/left/France/Fake_Bordeaux.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/France/Fake_Bordeaux.png
// module id = 2029
// module chunks = 4